<template>
  <div class="hyp-container">
    <v-container fluid bg fill-height grid-list-md text-center>
      <v-row row wrap align="center">
        <v-col>
          <Loader text="Loading Seerist" color="white" size="x-large"></Loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { logout } from "@/common/authenticate";

export default {
  name: "Login",
  async mounted() {
    console.log("Login component calling logout on mount"); //LOGOUT DEBUGGING
    await logout();
  },
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
};
</script>

<style scoped>
.bg,
.hyp-container {
  background: #191a1a;
  color: #fff;
}
</style>
